import { useLayoutEffect, useState } from 'react';

import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { isMobileApp } from 'hb-react/shared/utils/mobile';

import {
  VERTICAL_INSET_PER_ENV,
  VERTICAL_INSET_PER_MOBILE_APP_ENV,
} from '../constants/verticalInsetPerEnv';

const useToastVerticalInset = (env) => {
  const [verticalInset, setVerticalInset] = useState(0);
  const breakpoint = useBreakpoint();

  useLayoutEffect(() => {
    const verticalInsetSet = isMobileApp()
      ? VERTICAL_INSET_PER_MOBILE_APP_ENV
      : VERTICAL_INSET_PER_ENV;

    setVerticalInset(verticalInsetSet?.[env]?.[breakpoint]);
  }, [breakpoint, env]);

  return verticalInset;
};

export default useToastVerticalInset;
